import FormLayout from '../../../layout/FormLayout/FormLayout';
import FormWrapper from '../../../layout/FormWrapper/FormWrapper';
import FormCollapsableRow from '../../../layout/FormCollapsableRow/FormCollapsableRow';
import Input from '../../../../../components/Input/Input';
import SelectedValuesList from '../../../../../components/SelectedValuesList/SelectedValuesList';

const StorageViewAssetManager = ({ selectedData, onClose }: any) => {
    return (
        <FormWrapper mode={'view'}>
            <FormLayout
                title={'Asset managers'}
                description={'Here are the asset managers.'}
                onClose={onClose}
                useContentPadding={false}
                useSeparatorMargin={false}
            >
                <FormCollapsableRow
                    disabled={true}
                    titleLabel={'0. Inherited asset manager(s) from another structure'}
                />

                {selectedData.map((item: any, index: number) => (
                    <FormCollapsableRow
                        key={index}
                        titleLabel={`${index + 1}. asset manager`}
                        titleValue={`${item.role} :: ${item.counterparty}`}
                    >
                        <Input readOnly value={item.role}>
                            Role
                        </Input>

                        <Input disabled value={'Counterparty'}>
                            Agreement
                        </Input>

                        <Input readOnly value={item.counterparty} margin={false}>
                            Name
                        </Input>

                        <Input readOnly value={item.regulationFullName} margin={false}>
                            Regulatory status
                        </Input>
                    </FormCollapsableRow>
                ))}
            </FormLayout>
        </FormWrapper>
    );
};

export default StorageViewAssetManager;
